import FirstBannerSection from "./FirstBannerSection";
import Services from "./Services";
import OurTeam from "./OurTeam";
import Brand from "./Brand";
import Insurance from "./Insurance";
import VideoCarousel from "./VideoCarousel";

import Blogs from "./Blogs";
import Testimonials from "./Testimonials";
import WhyUs from "./WhyUs";
import { useGlobalData } from "../../contextApi/globalContextData";
// import SpinWheel from "../../utility/SpinWheel";
// import ScratchCard from "../../utility/ScratchCard";

const Homepage = () => {
  const { sectionsData, loading, error } = useGlobalData();

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error loading data.</p>;

  return (
    <>
      <VideoCarousel />
      {sectionsData["Banner"] && (
        <FirstBannerSection data={sectionsData["Banner"]} />
      )}
      {sectionsData["Services"] && <Services data={sectionsData["Services"]} />}

      <WhyUs />
      <div className="text-center" style={{ marginTop: "3rem" }}>
        <h3
          className="fw-bold fade-in"
          style={{ color: "#c69933", fontSize: "3rem" }}
        >
          Meet Our Specialists
        </h3>
      </div>
      {sectionsData["Professional"] && (
        <OurTeam data={sectionsData["Professional"]} />
      )}

      {sectionsData["Success Stories"] && (
        <Testimonials data={sectionsData["Success Stories"]} />
      )}
      <Blogs />
      {sectionsData["Brands"] && <Brand data={sectionsData["Brands"]} />}
      {sectionsData["Insurance"] && (
        <Insurance data={sectionsData["Insurance"]} />
      )}

      {/* <SpinWheel /> */}
      {/* <ScratchCard /> */}
      {/* <ContactUs /> */}
    </>
  );
};

export default Homepage;
